import { Button } from "@heroui/react"
import { ArrowPathIcon } from "@heroicons/react/20/solid"
import PropTypes from "prop-types"

const RefreshButton = ({ 
  color = "default", 
  handleClick, 
  isLoading = false, 
  variant = "flat" 
}) => (
  <Button className="border-white" onPress={() => handleClick()} color={color} variant={variant} isDisabled={isLoading} isIconOnly>
    <ArrowPathIcon className={`h-6 w-6 ${color === "white" ? "text-white" : ""} ${isLoading && "animate-spin"}`} />
  </Button>
)

RefreshButton.propTypes = {
  color: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  variant: PropTypes.string,
}

export default RefreshButton
